import React from 'react'
import styles from './StatusIcon.module.css'

const ErrorStatusIcon = () => (
    <div className={styles.iconWrapper}>
        <div className={`${styles.icon} ${styles.iconError}`}>✕</div>
    </div>
)

export default ErrorStatusIcon
